import { RECENT_SPACES_SECTION_ID } from '@atlassian/search-client';
import { useQuery } from '../../../query-context';

/**
 * This component performs any filtering on pre-query sections.
 */
export var PreQueryFilterTransformer = function PreQueryFilterTransformer(_ref) {
  var preQueryItems = _ref.preQueryItems,
    postQueryItems = _ref.postQueryItems,
    productState = _ref.productState,
    children = _ref.children;
  var _useQuery = useQuery(),
    query = _useQuery.query;
  var filteredPreQuerySections = query ? preQueryItems.sections : preQueryItems.sections.filter(function (section) {
    return section.id !== RECENT_SPACES_SECTION_ID;
  });
  var filteredPreQueryItems = {
    sections: filteredPreQuerySections,
    size: filteredPreQuerySections.map(function (section) {
      return section.searchResults.length;
    }).reduce(function (acc, b) {
      return acc + b;
    }, 0)
  };
  return children({
    preQueryItems: filteredPreQueryItems,
    postQueryItems: postQueryItems,
    productState: productState
  });
};